// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2geMY","toggle":"styles_toggle___6KFN","preview":"styles_preview__1wv_r"};